// extracted by mini-css-extract-plugin
module.exports = {"clientName":"PreviewPhotosession_clientName__1oVWq","clientNameMobile":"PreviewPhotosession_clientNameMobile__1Gwbp"};